export const blue = {
  lbBlueDark: '#1a2e58',
  lbBlue_100: '#3b5998',
  lbBlue_80: '#627aad',
  lbBlue_60: '#899bc1',
  lbBlue_40: '#b1bdd6',
  lbBlue_30: '#c4cde0',
  lbBlue_20: '#d8deea',
  lbBlue_10: '#ebeef5',
  lbBlue_5: '#f5f7fa',
} as const;

export const brightBlue = {
  lbBrightBlueDark: '#1831f4',
  lbBrightBlue_100: '#5467ff',
  lbBrightBlue_80: '#7685ff',
  lbBrightBlue_60: '#98a4ff',
  lbBrightBlue_40: '#bbc2ff',
  lbBrightBlue_20: '#dde1ff',
  lbBrightBlue_10: '#eef0ff',
  lbBrightBlue_5: '#f6f7ff',
} as const;

export const green = {
  lbGreenDark: '#00b81d',
  lbGreen_100: '#5ceb73',
  lbGreen_80: '#7def8f',
  lbGreen_60: '#9df3ab',
  lbGreen_40: '#bef7c7',
  lbGreen_20: '#defbe3',
  lbGreen_10: '#effdf1',
  lbGreen_5: '#f7fef8',
} as const;

export const orange = {
  lbOrangeDark: '#eb7911',
  lbOrange_100: '#ff9800',
  lbOrange_80: '#ff9800cc',
  lbOrange_60: '#ffc166',
  lbOrange_40: '#ffd699',
  lbOrange_20: '#ffeacc',
  lbOrange_10: '#fff5e5',
  lbOrange_5: '#fffaf2',
} as const;

export const red = {
  lbRedDark: '#d6082b',
  lbRed_100: '#ff143c',
  lbRed_80: '#ff4363',
  lbRed_60: '#ff728a',
  lbRed_40: '#ffa1b1',
  lbRed_20: '#ffd0d8',
  lbRed_10: '#ffe8eb',
  lbRed_5: '#fff3f5',
} as const;

export const purple = {
  lbPurpleDark: '#9077f6',
  lbPurple_100: '#ac98ff',
  lbPurple_80: '#bdadff',
  lbPurple_60: '#cdc1ff',
  lbPurple_40: '#ded6ff',
  lbPurple_20: '#eeeaff',
  lbPurple_10: '#f7f5ff',
  lbPurple_5: '#fbfaff',
} as const;

export const grey = {
  lbGreyDark: '#222326',
  lbGrey_50: '#909192',
  lbGrey_10: '#f5f6fa',
  lbTextSubdued: '#61656C',
} as const;

export const white = {
  lbWhite: '#ffffff',
} as const;

export const aliases = {
  lbText: grey.lbGreyDark,
  lbNew: green.lbGreen_100,
  lbRefactor: purple.lbPurple_100,
  lbRework: '#4451bf',
  lbGreyDisabled: '#bdc1c6',
} as const;

export const colorPalette = {
  ...blue,
  ...brightBlue,
  ...green,
  ...orange,
  ...red,
  ...purple,
  ...grey,
  ...white,
  ...aliases,
};
